import FinancialStatusCard from '@pages/Manage/components/FinancialStatusCard.tsx';
import { useManageFinance } from '@pages/Manage/useManageFinance';

export const FinancialStatusWidget = () => {
  const { year, totalPlanned, spentBudget, monthlyYtd, budgetsLoading } = useManageFinance({
    budgetsEnabled: true,
  });

  return (
    <FinancialStatusCard
      year={year}
      totalPlanned={totalPlanned}
      spent={spentBudget}
      monthlyYtd={monthlyYtd}
      loading={budgetsLoading}
      to="/manage/budget-details"
      compactValue
    />
  );
};

export default FinancialStatusWidget;
